import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/my-clans")({
  component: () => <Outlet />,
});
